
import * as BusinessDetailsActions from '../actions/business-details.actions';
import { BusinessDetailsState, initialState } from './business-details.state';
import { createReducer, on, Action } from '@ngrx/store';

export const businessDetailsFeatureKey = 'businessDetails';

export const businessDetailsReducer = createReducer(
  initialState,
  on(BusinessDetailsActions.SendBusinessDetailsSuccess, (state, {payload}) => ({
      ...state,
      businessDetails: payload
  })),
  on(BusinessDetailsActions.SearchBusinessNumberSuccess, (state, { payload }) => ({
    ...state,
    found: payload.found,
    legalName: payload.legalName,
    incorporationDate: payload.incorporationDate,
    orgBookDetails: payload
  })),
  on(BusinessDetailsActions.ClearBusinessNumber, (state,) => ({
    ...state,
    found: null,
    legalName: '',
    incorporationDate: '',
    isOrgBookServiceDown: null,
    orgBookDetails: {}
  })),
  on(BusinessDetailsActions.IsOrgBookServiceDown, (state,) => ({
    ...state,
    isOrgBookServiceDown: true,
  }))
);

export function reducer(state: BusinessDetailsState | undefined, action: Action) {
  return businessDetailsReducer(state, action);
}
